import { FinancialProductType } from 'generated/graphql';
import { useGetList } from 'react-admin';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useListProducts = (): { data: any[]; isLoading: boolean } => {
  const options = {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' as const },
  };

  const { data: buildingSavingsProducts, isLoading: isLoadingBuildingSavingsProducts } = useGetList(
    'BuildingSavingsProduct',
    options,
  );

  const { data: collisionInsuranceProducts, isLoading: isLoadingCollisionInsuranceProducts } = useGetList(
    'CollisionInsuranceProduct',
    options,
  );

  const { data: creditCardProducts, isLoading: isLoadingCreditCardProducts } = useGetList('CreditCardProduct', options);

  const { data: genericProducts, isLoading: isLoadingGenericProducts } = useGetList('GenericProduct', options);

  const { data: genericInsuranceProducts, isLoading: isLoadingGenericInsuranceProducts } = useGetList(
    'GenericInsuranceProduct',
    options,
  );

  const { data: investmentProducts, isLoading: isLoadingInvestmentProducts } = useGetList('InvestmentProduct', options);

  const { data: lifeInsuranceProducts, isLoading: isLoadingLifeInsuranceProducts } = useGetList(
    'LifeInsuranceProduct',
    options,
  );

  const { data: loanProducts, isLoading: isLoadingLoanProducts } = useGetList('LoanProduct', options);

  const { data: mortgageProducts, isLoading: isLoadingMortgageProducts } = useGetList('MortgageProduct', options);

  const { data: motorLiabilityInsuranceProducts, isLoading: isLoadingMotorLiabilityInsuranceProducts } = useGetList(
    'MotorLiabilityInsuranceProduct',
    options,
  );

  const { data: propertyInsuranceProducts, isLoading: isLoadingPropertyInsuranceProducts } = useGetList(
    'PropertyInsuranceProduct',
    options,
  );

  const { data: retirementPensionSavingsProducts, isLoading: isLoadingRetirementPensionSavingsProducts } = useGetList(
    'RetirementPensionSavingsProduct',
    options,
  );

  const { data: savingsProducts, isLoading: isLoadingSavingsProducts } = useGetList('SavingsProduct', options);

  const { data: supplementaryPensionSavingsProducts, isLoading: isLoadingSupplementaryPensionSavingsProducts } =
    useGetList('SupplementaryPensionSavingsProduct', options);

  const isLoading =
    isLoadingBuildingSavingsProducts ||
    isLoadingCollisionInsuranceProducts ||
    isLoadingCreditCardProducts ||
    isLoadingGenericProducts ||
    isLoadingGenericInsuranceProducts ||
    isLoadingInvestmentProducts ||
    isLoadingLifeInsuranceProducts ||
    isLoadingLoanProducts ||
    isLoadingMortgageProducts ||
    isLoadingMotorLiabilityInsuranceProducts ||
    isLoadingPropertyInsuranceProducts ||
    isLoadingRetirementPensionSavingsProducts ||
    isLoadingSavingsProducts ||
    isLoadingSupplementaryPensionSavingsProducts;

  const data = [
    ...(buildingSavingsProducts?.map((item) => ({ ...item, type: FinancialProductType.BuildingSavings })) ?? []),
    ...(collisionInsuranceProducts?.map((item) => ({ ...item, type: FinancialProductType.CollisionInsurance })) ?? []),
    ...(creditCardProducts?.map((item) => ({ ...item, type: FinancialProductType.CreditCard })) ?? []),
    ...(genericProducts?.map((item) => ({ ...item, type: FinancialProductType.Generic })) ?? []),
    ...(genericInsuranceProducts?.map((item) => ({ ...item, type: FinancialProductType.GenericInsurance })) ?? []),
    ...(investmentProducts?.map((item) => ({ ...item, type: FinancialProductType.Investment })) ?? []),
    ...(lifeInsuranceProducts?.map((item) => ({ ...item, type: FinancialProductType.LifeInsurance })) ?? []),
    ...(loanProducts?.map((item) => ({ ...item, type: FinancialProductType.Loan })) ?? []),
    ...(mortgageProducts?.map((item) => ({ ...item, type: FinancialProductType.Mortgage })) ?? []),
    ...(motorLiabilityInsuranceProducts?.map((item) => ({
      ...item,
      type: FinancialProductType.MotorLiabilityInsurance,
    })) ?? []),
    ...(propertyInsuranceProducts?.map((item) => ({ ...item, type: FinancialProductType.PropertyInsurance })) ?? []),
    ...(retirementPensionSavingsProducts?.map((item) => ({
      ...item,
      type: FinancialProductType.RetirementPensionSavings,
    })) ?? []),
    ...(savingsProducts?.map((item) => ({ ...item, type: FinancialProductType.Savings })) ?? []),
    ...(supplementaryPensionSavingsProducts?.map((item) => ({
      ...item,
      type: FinancialProductType.SupplementaryPensionSavings,
    })) ?? []),
  ];

  return { data, isLoading };
};
